import { Controller } from '@hotwired/stimulus';

// FIXME: jquery に依存しない構成に変更
export default class extends Controller {
  static targets = ['list'];

  // action="mouseover->header-sub-menu#open"
  open() {
    this.element.classList.add('is-selected');
    $(this.listTarget).stop().slideDown();
  }

  // action="mouseout->header-sub-menu#close"
  close() {
    this.element.classList.remove('is-selected');
    $(this.listTarget).stop().slideUp();
  }
}
